/**
 * @file Badge.jsx
 * @description Badge/tag para exibir informações com cores e tamanhos variados.
 * Reutilizável 
 * 
 * @exports Badge - Componente de badge
 * 
 * @example
 * <Badge variant="info" size="small">Informação</Badge>
 * <Badge variant="soon" icon={<Icon />}>Em breve</Badge>
 */

import './Badge.css';

export const Badge = ({
  children,
  variant = 'default',
  size = 'medium',
  icon,
  className = '',
  ...props
}) => {
  const classNames = [
    'badge',
    `badge--${variant}`,
    `badge--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classNames} {...props}>
      {icon && <span className="badge__icon">{icon}</span>}
      {children}
    </span>
  );
};
